import React from 'react';
import styles from './CoverCollection.module.scss';
import { collectionTypeOptions } from '@src/constants';
import { getMediaAbsolutePath } from '@src/services/File';
import type { DraggableProvided, DraggableStateSnapshot } from '@src/utils/componentCasts';
import { DragDropContext, Droppable, Draggable } from '@src/utils/componentCasts';
import LessonIcon from 'src/assets/icons/lesson_icon.svg?react';
import TimerIcon from 'src/assets/icons/time_icon.svg?react';
import ContentVideo from '../content-video/ContentVideo';

type Props = {
  id: string;
  isCollectionBlured: boolean;
  name: string;
  grade: string;
  bannerImage: string;
  bannerVideo: any;
  collectionType: string;
  type?: string;
  source?: string;
  target?: string;
  draggableProvided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  lessonCount: number;
  pacing?: string; // In lesson component it's called as `duration`
  onCardClick?: (e: React.MouseEvent<HTMLDivElement>, id: string) => void;
}

function CoverCollectionForProgram(props: Props) { 
  const { id, isCollectionBlured, name, bannerImage, bannerVideo, grade, collectionType, lessonCount, pacing, onCardClick } = props

  const isThemeType = collectionType === collectionTypeOptions[2].value

  const collectionCover = (type: String) => {
    switch (type) {
      case collectionTypeOptions[0].value: {
        return (
            <div className={styles.lessonContainer}>
                <p className={styles.individualLessonTitle}>Displayed as Individual Lessons</p>
                <p className={styles.gradeTitle}>{grade}</p>
            </div>);
      }
      case collectionTypeOptions[1].value: {
        return (
            <div className={styles.imageContainer}>
                {!!bannerImage ? (
                    <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                ) : null}
                {!bannerImage && bannerVideo ? (
                    <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} isCollection={true} />
                ) : null}
            </div>
        );
      }
      case collectionTypeOptions[2].value: {
        return (
          <>
            <div className={styles.themeContainerRectangle1}></div>
            <div className={styles.themeContainerRectangle2}></div>
            <div className={styles.themeContainerRectangle3}></div>
            <div className={styles.themeContainer}>
              <p className={styles.titleText}>Displays as Theme</p>
              <p className={styles.gradeTitle}>{grade}</p>
            </div>
          </>
        );
      }
      default: {
        return (
            <div className={styles.imageContainer}>
                {!!bannerImage ? (
                    <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                ) : null}
                {!bannerImage && bannerVideo ? (
                    <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} isCollection={true}/>
                ) : null}
            </div>
        );
      }
    }
  }


  return (
    <div className={`${styles.collectionCardContainer} ${isCollectionBlured && styles.cardOpacity}`} onClick={(e) => onCardClick && onCardClick(e, id)}>
        {isThemeType ? (
            <>
                <div className={styles.themeContainerRectangle1}></div>
                <div className={styles.themeContainerRectangle2}></div>
                <div className={styles.themeContainerRectangle3}></div>
            </>
        ) : (
            <>
                <div className={styles.containerRectangle1}></div>
                <div className={styles.containerRectangle2}></div>
                <div className={styles.containerRectangle3}></div>
            </>
        )}
        {collectionCover(collectionType)}
        <div className={styles.lessonMarkContainer}>
            <div className={styles.lessonCountContainer}>
                <LessonIcon />
                <p className={styles.lessonTitle}>
                    {lessonCount} Lessons
                </p>
            </div>
            {pacing && <div className={styles.lessonDurationContainer}>
                <TimerIcon />
                <p className={styles.lessonDurationTitle}>
                    {pacing} mins
                </p>
            </div>}
        </div>
        <div className={styles.titleContainer}>
            <p className={styles.title}>
                {name || ""}
            </p>
        </div>
       
    </div>
  )
}

export default CoverCollectionForProgram

